import { useLocation } from "react-router-dom";

export default function useIsCurrentPath(paths) {
  const location = useLocation();

  if (Array.isArray(paths)) {
    return paths.includes(location.pathname);
  }

  return location.pathname === paths;
}
